import { render, staticRenderFns } from "./SIWA.vue?vue&type=template&id=5c3aedbe&scoped=true"
import script from "./SIWA.vue?vue&type=script&lang=js"
export * from "./SIWA.vue?vue&type=script&lang=js"
import style0 from "./SIWA.vue?vue&type=style&index=0&id=5c3aedbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3aedbe",
  null
  
)

export default component.exports